import React from 'react';

import ProjectCreativeSnapshot from '../../../../components/project/project-creative-snapshot';
import ProjectPrintAds from '../../../../components/project/project-print-ads';
import ProjectBrandedMaterials from '../../../../components/project/project-branded-materials';
import ProjectDesignElement from '../../../../components/project/project-design-element';
import ProjectQuote from '../../../../components/project/project-quote';

const ADPCaseStudy = ({ acf }) => {
  return (
    <React.Fragment>
      <ProjectCreativeSnapshot
        image={acf.creative_snapshot_image}
        blurb={acf.creative_snapshot_blurb}
        wrapperPadding={'0'}
      />
      <ProjectPrintAds
        images={acf.print_ad_images}
        blurb={acf.print_ad_blurb}
        wrapperPadding={'10vw 0'}
      />
      <ProjectBrandedMaterials
        image={acf.branded_materials_image}
        blurb={acf.branded_materials_blurb}
        wrapperPadding={'0'}
      />
      <ProjectDesignElement
        image={acf.design_element_image}
        blurb={acf.design_element_blurb}
        wrapperPadding={'10vw 0 3vw 0'}
      />
      <ProjectQuote
        quote={acf.quote}
        name={acf.quote_name}
        title={acf.quote_title}
      />
    </React.Fragment>
  );
};

export default ADPCaseStudy;



// WEBPACK FOOTER //
// ./src/templates/project/case-studies/adp/index.js